// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleSquareFilledSvg from "@fishx/icons-svg/es/asn/DribbbleSquareFilled";
import FishxIcon from '../components/FishxIcon';

var DribbbleSquareFilled = function DribbbleSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareFilledSvg
  }));
};

DribbbleSquareFilled.displayName = 'DribbbleSquareFilled';
export default React.forwardRef(DribbbleSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DribbbleSquareFilled.js
// module id = 2473
// module chunks = 0